module.exports = __webpack_public_path__ + "img/AndroidTV_X9000F.3ab2baa2.png";